import { useEffect, useRef, useState } from 'react';
import { prefersReducedMotion } from '../helpers/motion';

// Anima o número exibido até `value` (ease-out cúbico). Valor final sempre exato.
// Não anima no mount, com valor não numérico nem com "reduzir movimento".
export function useTweenedNumber(value, ms = 300) {
  const [shown, setShown] = useState(value);
  const from = useRef(value); // último valor exibido: novo tween parte dele

  useEffect(() => {
    const origin = from.current;
    if (
      !Number.isFinite(value) ||
      !Number.isFinite(origin) ||
      value === origin ||
      prefersReducedMotion()
    ) {
      from.current = value;
      setShown(value);
      return undefined;
    }
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const t = Math.min(1, (now - start) / ms);
      const next =
        t === 1 ? value : origin + (value - origin) * (1 - (1 - t) ** 3);
      from.current = next;
      setShown(next);
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value, ms]);

  // Render em que o valor passa de NaN a finito: `shown` ainda é NaN até o effect rodar; usa o alvo.
  return Number.isFinite(shown) || !Number.isFinite(value) ? shown : value;
}
